// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"styles_menuButton__1RUEF","menuLink":"styles_menuLink__3a59I","menu":"styles_menu__3-KEH"};